function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3 0C1.34315 0 0 1.34315 0 3V27C0 28.6569 1.34315 30 3 30H27C28.6569 30 30 28.6569 30 27V3C30 1.34315 28.6569 0 27 0H3ZM7.11701 9.58425C7.29895 9.74964 7.39405 9.99359 7.36924 10.2375V19.0777C7.42712 19.3961 7.32375 19.7228 7.10048 19.9543L5 22.5055V22.8363H10.9541V22.5013L8.85363 19.9543C8.62621 19.7228 8.51871 19.4002 8.56419 19.0777V11.4325L13.7906 22.8404H14.3984L18.8929 11.4325V20.5208C18.8929 20.7606 18.8929 20.8102 18.7358 20.9673L17.1191 22.5344V22.8693H24.9628V22.5344L23.404 21.0046C23.2675 20.9012 23.1972 20.7275 23.2262 20.558V9.31135C23.1972 9.14182 23.2675 8.96816 23.404 8.86479L25 7.33492V7H19.4718L15.5313 16.8284L11.0492 7H5.25222V7.33492L7.11701 9.58425Z",
  fill: "currentColor"
});

var SvgMedium = function SvgMedium(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMedium, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/medium.10b6c1d2.svg";
export { ForwardRef as ReactComponent };